module.exports = "https://static.operabase.net/b7bdd8d6-054e-44d6-9034-858ec807a2db/_next/static/images/cueTvIcon-aab68c909ebfcf7a387cb99871806bd1.svg";